<div class="overflow-y-auto touch-pan-y" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()">
    <!-- Pull indicator -->
    <div class="text-center text-sm text-gray-500 transition-transform duration-200 ease-out"
        [style.transform]="'translateY(' + pullDistance() + 'px)'">
        @if (pullDistance() > 10) {
        @if (pullDistance() < threshold) { Pull to refresh... } @else { Release to refresh } } </div>

            <!-- Projected content -->
            <ng-content />
    </div>